import { ShippingTypesCodes } from '@/data/libraries/ShippingTypes';
import { IStateFlow } from '@/domain/interfaces/IStatus';
import { translate } from '@/domain/utils/translate';

/**
 * Librería de códigos de Status
 */
export enum StatusCodes {
  ACTIVE = 1,
  INACTIVE = 2,
  PENDING = 3,
  REJECTED_PAY = 4,
  ACCEPTED_PAY = 5,
  FINALIZED = 6,
  PROCESSING = 7,
  CANCELED = 8,
  ORDER_PROCESSING = 9,
  ORDER_PENDING = 10,
  ORDER_SENT = 11,
  ORDER_DELIVERED = 12,
  ORDER_CANCELED = 13,
  ORDER_ERROR = 14,
  ORDER_BRANCH_PICKUP = 15,
}

export const getStatusList = (): IStateFlow[] => ([
  {
    id: StatusCodes.ACTIVE,
    name: translate('general.status.active'),
    className: 'text-complementary-1',
  },
  {
    id: StatusCodes.INACTIVE,
    name: translate('general.status.inactive'),
    className: 'text-complementary-2',
  },
  {
    id: StatusCodes.PENDING,
    name: translate('general.status.pending'),
  },
  {
    id: StatusCodes.REJECTED_PAY,
    name: translate('general.status.rejected_pay'),
  },
  {
    id: StatusCodes.ACCEPTED_PAY,
    name: translate('general.status.accepted_pay'),
  },
  {
    id: StatusCodes.FINALIZED,
    name: translate('general.status.finalized'),
  },
  {
    id: StatusCodes.PROCESSING,
    name: translate('general.status.processing'),
  },
  {
    id: StatusCodes.CANCELED,
    name: translate('general.status.canceled'),
  },
  {
    id: StatusCodes.ORDER_PENDING,
    name: translate('general.status.order_pending'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.NATIONAL_SHIPMENT,
  },
  {
    id: StatusCodes.ORDER_PROCESSING,
    name: translate('general.status.order_processing'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.NATIONAL_SHIPMENT,
  },
  {
    id: StatusCodes.ORDER_SENT,
    name: translate('general.status.order_sent'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.NATIONAL_SHIPMENT,
  },
  {
    id: StatusCodes.ORDER_DELIVERED,
    name: translate('general.status.order_delivered'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.NATIONAL_SHIPMENT,
  },
  {
    id: StatusCodes.ORDER_CANCELED,
    name: translate('general.status.order_canceled'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.NATIONAL_SHIPMENT,
  },
  {
    id: StatusCodes.ORDER_ERROR,
    name: translate('general.status.order_error'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.NATIONAL_SHIPMENT,
  },

  {
    id: StatusCodes.ORDER_PENDING,
    name: translate('general.status.order_pending'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.PICK_UP,
  },
  {
    id: StatusCodes.ORDER_PROCESSING,
    name: translate('general.status.order_processing'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.PICK_UP,
  },
  {
    id: StatusCodes.ORDER_BRANCH_PICKUP,
    name: translate('general.status.order_in_office'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.PICK_UP,
  },
  {
    id: StatusCodes.ORDER_DELIVERED,
    name: translate('general.status.order_delivered'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.PICK_UP,
  },
  {
    id: StatusCodes.ORDER_CANCELED,
    name: translate('general.status.order_canceled'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.PICK_UP,
  },
  {
    id: StatusCodes.ORDER_ERROR,
    name: translate('general.status.order_error'),
    allowedTransitions: [],
    shippingTypeId: ShippingTypesCodes.PICK_UP,
  },
]);

export default StatusCodes;
